export default __webpack_public_path__ + "static/media/news247121.ade8e6f5.png";